export default {
  feedback: {
    login_success: 'Du er nu logget ind',
    logout_success: 'Du er nu logget ud',
  },
};
